import { InputAdornment } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { FC, useEffect, useState } from 'react';

type ExportProps = {
  name: string;
  data: object | object[];
  open: boolean;
  onClose: () => void;
};

const Export: FC<ExportProps> = (props) => {
  const [filename, setFilename] = useState<string>();

  const exportFile = () => {
    const data = {
      exported: new Date().toISOString(),
      ...props.data
    };
    const jsonData = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonData], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.download = `${filename}.json`;
    a.href = url;

    // Append the anchor to the body to ensure it works on Firefox.
    document.body.appendChild(a);

    // Programmatically click the link to start the download.
    a.click();

    // Clean-up: remove the anchor from the body and revoke the object URL.
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleExport = () => {
    exportFile();
    props.onClose();
  };

  useEffect(() => setFilename(props.name), [props.open]);

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth='md'>
      <DialogTitle>Export Log</DialogTitle>
      <DialogContent>
        <TextField
          label='filename'
          size='small'
          autoFocus={props.open}
          value={filename}
          onChange={(event) => setFilename(event.target.value)}
          fullWidth
          InputProps={{
            autoComplete: 'off',
            endAdornment: <InputAdornment position='end'>.json</InputAdornment>
          }}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color='primary'>
          Cancel
        </Button>
        <Button onClick={handleExport} color='primary'>
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Export;
